const common: Record<string, string> = {
  "site.name": "CSSBuy Spreadsheet",
  "site.tagline": "Planilha Inteligente. Compras sem Fronteiras.",
  "nav.hub": "HUB",
  "nav.categorias": "CATEGORIAS",
  "nav.guias": "GUIAS",
  "nav.blog": "BLOG",
  "hero.title_line1": "CSSBUY",
  "hero.title_line2": "SPREADSHEET",
  "hero.subtitle": "Descubra os melhores produtos da China com nossa planilha atualizada diariamente. Sneakers, streetwear, acessórios e muito mais — tudo verificado e organizado para você importar com segurança.",
  "hero.cta_spreadsheet": "CSSBUY SPREADSHEET",
  "hero.cta_buy": "BUY IT NOW",
  "hero.select_category": "SELECIONE UMA CATEGORIA",
  "categories.title_label": "CATEGORIAS DA PLANILHA",
  "categories.title": "Explore Nossas Categorias",
  "categories.description": "Navegue por todas as categorias disponíveis na planilha CSSBuy. Cada categoria é atualizada diariamente com novos produtos verificados.",
  "features.label": "POR QUE USAR NOSSA PLANILHA",
  "features.title": "A Ferramenta Mais Completa para Importar da China",
  "features.atualizacao.title": "Atualização Diária",
  "features.atualizacao.desc": "Nossa planilha é atualizada todos os dias com novos produtos, preços e avaliações de qualidade para garantir que você sempre tenha acesso às melhores oportunidades.",
  "features.precos.title": "Preços Verificados",
  "features.precos.desc": "Cada produto na planilha passa por verificação de preço. Comparamos múltiplos agentes para garantir que você pague o menor valor possível em cada compra.",
  "features.envio.title": "Envio Global",
  "features.envio.desc": "Informações completas sobre opções de envio para Europa, Américas e Ásia. Calculamos prazos e custos para cada região, facilitando seu planejamento.",
  "gallery.label": "PRODUTOS EM DESTAQUE",
  "gallery.title": "Descubra Produtos",
  "gallery.title_italic": "Exclusivos",
  "gallery.view_link": "Ver na Planilha",
  "dark.label": "CSSBUY SPREADSHEET HUB 2026",
  "dark.title1": "Economize Tempo.",
  "dark.title2": "Encontre Peças.",
  "dark.title3": "Importe Fácil.",
  "dark.cta_access": "Acessar Planilha",
  "dark.cta_compare": "Comparar Preços",
  "dark.feature1": "Planilha Atualizada",
  "dark.feature2": "Busca Inteligente",
  "dark.feature3": "Cupons Ativos",
  "dark.feature4": "Análise de Risco",
  "dark.feature5": "Envio Europa",
  "articles.label": "CONTEÚDO SEO",
  "articles.title": "Guias & Reviews",
  "articles.card1.title": "O Que é CSSBuy Spreadsheet?",
  "articles.card1.desc": "Guia completo e definitivo sobre a planilha CSSBuy: como funciona, como acessar e como aproveitar ao máximo para economizar nas suas importações da China em 2026.",
  "articles.card1.link": "/guia-cssbuy-spreadsheet-2026",
  "articles.read_more": "Ler mais",
  "cta_banner.line1": "Planilha CSSBuy atualizada.",
  "cta_banner.line2": "Todos os dias. Novos produtos.",
  "cta_banner.line3": "Comece a economizar agora.",
  "cta_banner.button": "COMPRAR AGORA EM CSSBUY",
  "footer.categorias": "Categorias",
  "footer.guias": "Guias",
  "footer.legal": "Legal",
  "footer.redes": "Redes",
  "footer.copyright": "© 2026 cssbuyspreadsheet.wtf",
  "footer.privacy": "Privacidade",
  "footer.subscribe_placeholder": "Seu melhor email",
  "footer.promo": "Planilha inteligente.",
  "footer.promo2": "Compras sem fronteiras.",
};

export default common;